import { call, fork, takeLatest } from 'redux-saga/effects';

import { importEfectores } from '../api';

import { efectoresImportLogActions } from './actions';

export function* uploadEfectores({payload}) {
    const { file } = payload
    yield call(importEfectores, file)
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchUploadEfectores() {
    yield takeLatest(efectoresImportLogActions.UPLOAD_EFECTORES, uploadEfectores);
  }

//=====================================
//  ROOT
//-------------------------------------

export const efectoresImportLogSagas = [
  fork(watchUploadEfectores)
];
